<template>
  <div class="activity-tab">
    <div>
      <div class="title active">
        <span>{{ title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityTitle',
  props: {
    title: String,
  },
  data() {
    return {}
  },
}
</script>
<style scoped lang="scss">
.activity-tab {
  height: 112px;
  text-align: center;
  margin: 30px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    display: flex;
    align-items: center;
    margin: 0 60px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: url('https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/home-title-bg.png');
    background-size: 100% 100%;
    line-height: 40px;

    span {
      padding: 0 16px;
    }
    img {
      width: 32px;
      height: 11px;
      opacity: 0;
    }
  }
}
</style>
